import cloneDeep from "lodash.clonedeep";
import { useFieldArray, useFormContext, useWatch } from "react-hook-form";
import { Table } from "stories";
import { currencyStyle } from "utils/customHooks/currencyFormat";
import { v4 as uuidv4 } from "uuid";
import { getColumnTotal } from "../../equityBreakdown";
const rowPricePSFCalculator = (row, rows) => {
  if (
    !isNaN(parseFloat(row.avg_price)) &&
    !isNaN(parseFloat(row.avg_sq_ft)) &&
    !isNaN(row.avg_price / row.avg_sq_ft)
  ) {
    return `$ ${currencyStyle(
      Number((parseFloat(row.avg_price) / parseFloat(row.avg_sq_ft)).toFixed(2))
    )}`;
  } else {
    return "-";
  }
};

const rowTotalMarketValue = (row, rows) => {
  if (!isNaN(parseFloat(row.avg_price)) && !isNaN(parseFloat(row.count))) {
    return `$ ${currencyStyle(
      Number((parseFloat(row.avg_price) * parseFloat(row.count)).toFixed(2))
    )}`;
  } else {
    return "-";
  }
};

const tableHeader = (projectPurpose) => [
  {
    id: "title",
    title: "Unit Type",
    align: "left",
  },
  {
    id: "count",
    title: "Count",
    align: "right",
  },
  {
    id: "avg_sq_ft",
    title: "Avg SF/Unit",
    align: "right",
  },
  {
    id: "avg_price",
    title:
      projectPurpose === "sale" ? "Avg Market Value" : "Annual Unit Revenue",
    align: "right",
  },
  {
    id: "avg_price_psf",
    title: projectPurpose === "sale" ? "Avg Price PSF" : "Avg Revenue PSF",
    align: "right",
  },
  {
    id: "total_market_value",
    title:
      projectPurpose === "sale" ? "Total Market Value" : "Total Annual Revenue",
    align: "right",
  },
];

export const getEmptyRow = () => ({
  uid: uuidv4(),
  title: "",
  count: null,
  avg_sq_ft: null,
  avg_price: null,
  avg_price_psf: rowPricePSFCalculator,
  total_market_value: rowTotalMarketValue,
  props: {
    deletable: true,
    title: {
      editable: true,
    },
    count: {
      editable: true,
      type: "currency",
      prefix: "",
    },
    avg_sq_ft: {
      editable: true,
      type: "currency",
      prefix: "",
    },
    avg_price: {
      editable: true,
      type: "currency",
    },
  },
});

//eslint-disable-next-line
const calulateFooterData = (rows) => {
  return [
    {
      uid: "summery-x",
      title: "Summery",
      count: currencyStyle(getColumnTotal(rows, "count")),
      avg_sq_ft: `--`,
      avg_price: `--`,
      avg_price_psf: `--`,
      total_market_value: `$ ${currencyStyle(
        getColumnTotal(rows, "total_market_value")
      )}`,
    },
  ];
};

export const AssetBreakdownTable = ({ dataKey, prefixKey, title = "Unit" }) => {
  const form = useFormContext();
  const {
    fields: rows,
    append: addRow,
    update,
    remove: onDelete,
  } = useFieldArray({
    control: form.control,
    name: `${prefixKey ? prefixKey + "." : ""}${dataKey}`,
    keyName: "key",
  });

  const projectPurpose = useWatch({
    control: form.control,
    name: "project_purpose",
  });

  const addNewRow = () => {
    addRow(getEmptyRow());
  };

  const handleOnChange = (index, cellId, value) => {
    update(index, {
      ...rows[index],
      [cellId]: value,
    });
  };

  // const footerData = calulateFooterData(rows);
  const tmpRows = cloneDeep(rows);
  if (tmpRows.length === 1) {
    tmpRows[0].props.deletable = false;
  }

  const headers = tableHeader(projectPurpose);
  headers[0].title = title + " Type";
  return (
    <>
      <Table
        sameColumnWidth
        headers={headers}
        rows={tmpRows}
        // footer={footerData}
        onFieldChanged={handleOnChange}
        onDelete={onDelete}
      />

      <div
        className={"fw-bold text-primary mb-3 d-inline-block"}
        role={"button"}
        onClick={addNewRow}
      >
        + Add Unit/Type
      </div>
    </>
  );
};
